import {post} from '../utils/http'

export default {
  getUserAuthInfo:function (param) {
    return post('/userinfo/getuserinfo', param)
  },
  postInitMember: (params) => {
    return post("/mo/member/initMember", params)
  },
  getFannalyToken:function () {
    return get('/fannaly')
  },
  checkFannalyMember:function (param) {
    return post('/fannaly/checkFannalyMember', param, true)
  },
  registerFannalyMember:function (param) {
    return post('fannaly/registerFannalyMember', param, true)
  },
  updateFannalyMember:function (param) {
    return post('fannaly/updateFannalyMember', param)
  },
  summaryFannalyMember:function (param) {
    return post('fannaly/summaryFannalyMember', param)
  },
  getFannalyCoupons:function (param) {
    return post('fannaly/getFannalyCoupons', param)
  },
  useFannalyCoupon:function (param) {
    return post('fannaly/useFannalyCoupon', param)
  },
  enableRegistrationCompleted:function (param) {
    return post('fannaly/enableRegistrationCompleted', param)
  },
  syncStampDataFromFa:function (param) {
    return post('mo/partner_user/sync_fa_data', param)
  },
  updateMembershipCardNumber:function (param) {
    return post('mo/member_detail/update_membership_card', param)
  },
}


